import {Component} from "@angular/core";

@Component({
  selector: "app-earnings",
  templateUrl: "./earnings.component.html",
  styleUrls: ["./earnings.component.scss"],
})
export class EarningsComponent {}
